import { newE2EPage } from '@stencil/core/testing';

describe('jackery-comment-item', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-comment-item></jackery-comment-item>');

    const element = await page.find('jackery-comment-item');
    expect(element).toHaveClass('hydrated');
  });
});
